import { Box } from '@mui/material';
import billetLogo from '@/assets/img/billetLogo.png';

const BilletLogo = () => (
  <Box display="flex" justifyContent="center" pt={2}>
    <Box component="img" src={billetLogo} alt="Billet Logo" sx={{ maxWidth: 260 }} />
  </Box>
);

export default BilletLogo;